
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_sites/[site]/login",
      function () {
        return require("private-next-pages/_sites/[site]/login/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/_sites/[site]/login"])
      });
    }
  